/*
 * Der Versandschalter — die Leseseite.
 *
 * Dieselbe Regel steht im Backend (`services/email/dispatchMode`). Sie gehoert
 * an beide Enden: Der Server entscheidet, wohin eine Mail geht; die Ansicht
 * muss denselben Zustand zeigen, sonst steht im Admin-Bereich „Testbetrieb",
 * waehrend die Anwendung laengst wieder hinausschickt.
 */

export const DISPATCH_PRODUCTION = 'PRODUCTION'
export const DISPATCH_TEST = 'TEST'

/** Die Dauern, die zur Auswahl stehen. Der Server laesst nur 30 bis 90 zu. */
export const TEST_WINDOW_CHOICES = [30, 60, 90]

/**
 * Welche Betriebsart gilt gerade?
 *
 * @param {object} options Alle Einstellungen, wie sie im Redux-Zweig liegen.
 * @param {Date}   jetzt   Vergleichszeitpunkt (fuer Tests uebergebbar).
 * @returns {{ mode: string, testUntil: Date|null, secondsLeft: number }}
 *
 * Alles, was nicht ausdruecklich ein laufendes Testfenster ist, ist
 * Produktivversand: fehlende Einstellung, unbekannter Inhalt, unlesbares
 * Datum, abgelaufenes Fenster. Genau wie im Backend — in den Testbetrieb
 * rutscht man nicht hinein.
 */
export function readEmailDispatch(options, jetzt = new Date()) {
	const aus = { mode: DISPATCH_PRODUCTION, testUntil: null, secondsLeft: 0 }
	const wert = options?.emailDispatch

	if (!wert || typeof wert !== 'object') return aus
	if (wert.mode !== DISPATCH_TEST) return aus
	if (!wert.testUntil) return aus

	const bis = new Date(wert.testUntil)
	if (Number.isNaN(bis.getTime())) return aus

	const verbleibend = bis.getTime() - jetzt.getTime()
	if (verbleibend <= 0) return aus

	return { mode: DISPATCH_TEST, testUntil: bis, secondsLeft: Math.ceil(verbleibend / 1000) }
}

export default readEmailDispatch
